"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7119],{

/***/ 47119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_VehicleDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/index.tsx + 10 modules
var components = __webpack_require__(75713);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/VehicleDetails/Column.tsx





var Column = function Column(_ref) {
  var title = _ref.title,
      items = _ref.items;
  var isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
    allowToggle: true,
    allowMultiple: true,
    defaultIndex: 0,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
      border: "0",
      borderBottom: "1px solid #dadde1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
          p: "m",
          _hover: {
            background: 'none'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            flex: "1",
            textAlign: "left",
            fontSize: "1rem",
            fontFamily: "Montserrat-SemiBold",
            textTransform: "uppercase",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
        pb: 4,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          children: items && items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
              columns: 2,
              w: "100%",
              p: "12px",
              className: "accordion-item-mobile-bordered",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontFamily: "Montserrat-Regular",
                fontSize: "1rem",
                letterSpacing: ".2px",
                color: "baseDark",
                display: "inline",
                textTransform: "uppercase",
                textAlign: "left",
                children: item.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontFamily: "Montserrat-SemiBold",
                fontSize: "1.1rem",
                letterSpacing: ".3px",
                color: "baseDark",
                display: "inline",
                textAlign: "right",
                children: item.value
              })]
            }, item.name);
          })
        })
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    w: "full",
    bg: "baseWhite",
    p: 6,
    overflow: "hidden",
    padding: "unset",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      fontFamily: "Montserrat-SemiBold",
      fontSize: ".875rem",
      lineHeight: "18px",
      letterSpacing: ".2px",
      textAlign: "center",
      color: "baseDark",
      textTransform: "uppercase",
      paddingY: "m",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      bg: "baseNeutral.300",
      height: ".125rem"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
      paddingX: "xl",
      paddingY: "l",
      children: items.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
          position: "relative",
          textAlign: "left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            paddingY: ".875rem",
            paddingX: "s",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
              fontFamily: "Montserrat-Regular",
              fontSize: "1rem",
              lineHeight: "20.8px",
              letterSpacing: ".2px",
              color: "baseDark",
              display: "inline",
              textTransform: "uppercase",
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
              fontFamily: "Montserrat-SemiBold",
              fontSize: "1.1rem",
              lineHeight: "23px",
              letterSpacing: ".3px",
              float: "right",
              color: "baseDark",
              display: "inline",
              children: item.value
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
            bg: "baseNeutral.300",
            height: ".062rem"
          })]
        }, "".concat(item.name, "-").concat(item.value));
      })
    })]
  });
};

/* harmony default export */ var VehicleDetails_Column = (Column);
;// CONCATENATED MODULE: ./src/components/VehicleDetails/index.tsx








var TitleContent = styled_components_browser_esm["default"].span.withConfig({
  displayName: "VehicleDetails__TitleContent",
  componentId: "sc-1xcx72b-0"
})(["& svg{display:inline;margin-right:0.5rem;margin-bottom:-6px;}"]);

var VehicleDetails = function VehicleDetails(_ref) {
  var title = _ref.title,
      engineTitle = _ref.engineTitle,
      engine = _ref.engine,
      dimensionsTitle = _ref.dimensionsTitle,
      dimensions = _ref.dimensions,
      consumptionTitle = _ref.consumptionTitle,
      consumption = _ref.consumption;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bg: "baseNeutral.200",
    paddingY: {
      base: 0,
      md: 'xxl6'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Container */.W2, {
      paddingY: "0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        bg: "baseNeutral.300",
        padding: "m",
        borderTopRadius: {
          base: '0',
          md: '10'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          as: "h2",
          fontFamily: "Montserrat-SemiBold",
          fontSize: {
            base: '1.25rem',
            md: '1.5rem'
          },
          lineHeight: "31px",
          letterSpacing: {
            base: '0.58px',
            md: '0.68px'
          },
          textAlign: "center",
          color: "baseDark",
          py: "xxl",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContent, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
              display: {
                base: 'none',
                md: 'inline'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreyCarIcon */.qb, {})
            }), title]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          sm: 2,
          md: 3
        },
        spacing: "l",
        textAlign: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetails_Column, {
          title: engineTitle,
          items: engine
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetails_Column, {
          title: dimensionsTitle,
          items: dimensions
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetails_Column, {
          title: consumptionTitle,
          items: consumption
        })]
      })]
    })
  });
};

/* harmony default export */ var components_VehicleDetails = (VehicleDetails);

/***/ })

}]);